import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface OkCancelDialogData {
  title?: string;
  text?: string;
  buttonText?: string;
  cancelButtonText?: string;
  hideConfirmButton?: boolean;
}

@Component({
  selector: 'ok-cancel-dialog',
  templateUrl: './ok-cancel-dialog.component.html',
  styleUrls: ['./ok-cancel-dialog.component.scss'],
})
export class OkCancelDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OkCancelDialogData,
    private dialogRef: MatDialogRef<OkCancelDialogComponent>
  ) {}
  onCloseClick(isOk: boolean) {
    this.dialogRef.close(isOk);
  }
}
